<template>
  <BgImageLayout>
    <template #title>
      <EntityEditor
        :params="titleList"
        :options="null"
        :value="titleList ? titleList.name : null"
        title="Name"
        type="text"
        positioned-high
        class="col title-list-name"
        @update="saveEdit({ name: $event })"
      >
        <template slot="content">
          <span v-if="titleList">{{ titleList.name }}</span>
          <q-spinner v-else color="primary" size="1.5em" />
        </template>
      </EntityEditor>
    </template>

    <Grid class="content fit" gap="20px" gtr="auto 1fr">
      <div class="info-card-wrapper">
        <LmTitleListInfo class="info-card" />
      </div>

      <div class="table-wrapper">
        <PublicationsTable />
      </div>

      <LmDialog
        v-for="action in topBarActions"
        :key="action.uid"
        :uid="action.dialogUid"
        :entity="titleList"
        :callback="redirectToProduct"
        store-namespace="titleLists"
      />
    </Grid>
  </BgImageLayout>
</template>

<script>
import { uid } from 'quasar'
import { mapState, mapActions } from 'vuex'
import TitleListsShowModule from './vuex/TitleListShow'
// Components
import EntityEditor from '@components/editors/EntityEditor'
import LmDialog from '@components/lm-blocks/Dialog'
import PublicationsTable from './components/publications-table/PublicationsTable'
import LmTitleListInfo from './components/TopBar/Info/Info'

export default {
  name: 'LmPageTitleListShow',

  components: {
    EntityEditor,
    LmDialog,
    PublicationsTable,
    LmTitleListInfo
  },

  props: {
    id: [Number, String] // from route
  },

  computed: {
    ...mapState('title-list-show', ['titleList']),

    topBarActions() {
      if (!this.titleList) return
      return {
        delete: {
          name: 'delete',
          action: 'titleLists/deleteConfirmation',
          id: this.id,
          dialogUid: uid()
        }
      }
    }
  },

  beforeCreate() {
    this.$store.registerModule('title-list-show', TitleListsShowModule)
  },

  created() {
    this.getAndSetTitleList(this.id)
  },

  destroyed() {
    this.$store.unregisterModule('title-list-show')
  },

  methods: {
    ...mapActions('title-list-show', ['getAndSetTitleList', 'updateTitleList']),

    redirectToProduct() {
      return this.$router.push({
        name: 'product',
        params: { id: this.titleList.product.id }
      })
    },

    saveEdit(payload) {
      this.updateTitleList({ id: this.titleList.id, payload })
    }
  }
}
</script>

<style lang="stylus" scoped>
.content {
  .info-card-wrapper {
    height 210px
    background #E6E6E6
    padding 20px
    box-shadow 0 2px 0 #BDC6CC

    > .info-card {
      background white
      padding 15px
    }
  }

  .table-wrapper {
    background #E6E6E6
    padding 20px
  }
}
</style>
